/**
 * @file CapSmartResize
 * @module Capitan/es6/CapSmartResize
 * @copyright Brandung GmbH & Co KG
 * @author Sebastian Steiner
 * @version 2.0
 * @license MIT License (MIT)
 * @date 21.01.2018
 *
 */

/**
 * Method to debounce a given function on resize
 *
 * @param {function} func - function to be called
 * @param {number} [threshold=100] - wait time before executing the function
 * @param {bool} [execAsap=true] - execute function directly on resize or after
 * @param {object} [context=tthis] - can set different context if needed
 * @param {any} args - arguments for function
 */
const CapSmartResize = (func, threshold = 100, execAsap, context = this, ...args) => {
  let timeout = null;

  const debounced = () => {
    if (timeout) {
      clearTimeout(timeout);
    } else if (execAsap) {
      func.apply(context, args);
    }

    timeout = setTimeout(() => {
      !execAsap && func.apply(context, args);
      timeout = null;
    }, threshold);
  };

  window.addEventListener('resize', debounced);
};

export default CapSmartResize;